import { Slider } from '@mui/material';
import { styled } from '@mui/system';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';

export const RootDiv = styled('div')({
  width: '100%',
  backgroundColor: 'white',
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  padding: '16px',
  borderBottom: '1px solid #e0e0e0',
});

export const TopContainer = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: '9px',
  color: '#15365F',
});

export const TitleContainer = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '4px',
});

export const LocalShippingIcon = styled(LocalShippingOutlinedIcon)({
  fontSize: '16px',
});

export const TitleTypography = styled('div')({
  fontSize: '12px',
  fontWeight: '500',
  lineHeight: '16px',
  letterSpacing: '0.15px',
});

export const PriceContainer = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
});

export const PriceTypography = styled('div')({
  fontSize: '12px',
  fontWeight: '500',
  lineHeight: '16px',
  letterSpacing: '0.15px',
});

export const MessageTypography = styled('div')(({ theme }) => ({
  fontSize: '12px',
  fontWeight: '400',
  lineHeight: '16px',
  letterSpacing: '0.15px',
  color: '#15365F',
  '& span': {
    fontWeight: '600',
    color: theme.palette.primary.main,
  },
}));

export const FreeDeliveryProgressSlider = styled(Slider)(({ theme }) => ({
  height: '4px',
  width: '98%',
  '& .MuiSlider-thumb': {
    height: '8px',
    width: '8px',
  },
  '&.Mui-disabled': {
    padding: '2px 0px',
    color: theme.palette.primary.main,
    '& .MuiSlider-track': {
      backgroundColor: theme.palette.primary.main,
    },
  },
}));
